import { Collection } from 'backbone';
import { LocalStorage } from 'backbone.localstorage';

import CartItemModel from './cartItemModel';

// Backbone cart items Collection.
const CartItemsList = Collection.extend({
  model: CartItemModel,
  localStorage: new LocalStorage('vtc-cart-items'),
  selected() {
    return this.where({ selected: true });
  },
  unSelected() {
    return this.where({ selected: false });
  },
  comparator(a, b) {
    return a.get('order') < b.get('order') ? -1 : 1;
  },
});

const CartItems = new CartItemsList();

export default CartItems;
